module.exports = __webpack_public_path__ + "img/quiz.df6c540d.svg";